<template>
  <TenderStep
    :current-step="currentStep"
    :total-steps="totalSteps"
    :error-transition="false"
  >
    <template slot="header">
      <div class="text-base font-normal text-[#4a4a4a]">
        {{ $t("requestTender.phone.subtitle") }}
      </div>
      <div class="question-big">
        {{ $t("requestTender.phone.question") }}
      </div>
    </template>

    <JoszakiPhoneInput
      ref="phoneInput"
      v-model="newTender.phone.value"
      customer-only
      :placeholder="$t('requestTender.phone.placeholder')"
      :show-error-msg="false"
      :validation-state="phoneValidation"
      @validity-change="phoneValid = $event"
      @focusout.native="touched = true"
      @keyup.enter.exact.native="emitNext('enter')"
    />

    <template slot="error">
      <div v-if="touched && !phoneValid">
        {{ phoneErrorMessage }}
      </div>
    </template>

    <template slot="footer">
      <WizardNextButton :disabled="!phoneValid" @click="emitNext()" />
    </template>
  </TenderStep>
</template>

<script>
import { toRefs } from "@nuxtjs/composition-api";
import WizardNextButton from "./WizardNextButton.vue";
import TenderStep from "@/components/TenderStep";
import { useNewTender } from "~/composables/tender/useNewTender";
import { useTrackWizardClick } from "~/composables/tracking/useTrackWizardClick";

export default {
  name: "PhoneStepModule",
  components: { TenderStep, WizardNextButton },
  props: {
    currentStep: { type: Number, required: true },
    totalSteps: { type: Number, required: true },
    moduleSlug: { type: String, default: "phone" },
  },
  emits: ["next"],
  setup(props) {
    const { trackNextAttempt } = useTrackWizardClick(toRefs(props));
    return { trackNextAttempt, newTender: useNewTender() };
  },
  data() {
    return {
      // Pushed up by JoszakiPhoneInput (validity-change fires immediately on
      // mount, mirroring the old `immediate` vee-validate provider). Covers
      // both required-ness and the libphonenumber mobile-format check.
      phoneValid: false,
      touched: false,
    };
  },
  computed: {
    phoneValidation() {
      return this.newTender.v$.value.phone;
    },
    phoneErrorMessage() {
      // The format check lives inside JoszakiPhoneInput's own vuelidate
      // instance and isn't exposed as a message, so fall back to the same
      // string the old `uj-mobil` rule produced.
      return (
        this.phoneValidation.number?.$errors?.[0]?.$message ||
        this.$t("validations.phoneNumberMobile")
      );
    },
  },
  methods: {
    emitNext(trigger = "click") {
      this.trackNextAttempt({ trigger, disabled: !this.phoneValid });
      if (!this.phoneValid) {
        this.touched = true;
        return;
      }
      this.newTender.saveToStorage();
      this.$emit("next", { field: "phone" });
    },
  },
};
</script>
